<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.surveys', 2),
                        href: meta.links.survey_index,
                    },
                    {
                        name: $tc('messages.survey_reports', 2),
                        href: meta.links.survey_records_index,
                    },
                    {
                        name: survey.title,
                        href: null,
                    },
                    {
                        name: $t('messages.survey_answer_similarities'),
                        href: null,
                    },
                ]"
            />
        </template>
        <div>
            <AppWell>
                <div class="p-2">
                    <AppCard :id="`q_${question.id}`">
                        <div class="p-1">
                            <div class="flex justify-between">
                                <div>
                                    <span>{{ question.title }}</span>
                                    <span v-if="question.is_required" class="text-red-600"> *</span>
                                </div>
                            </div>
                            <div v-if="question.description" class="mt-1">
                                <p class="text-gray-700">{{ question.description }}</p>
                            </div>
                            <div v-show="false">
                                {{ question.type }}
                            </div>
                        </div>
                    </AppCard>
                </div>
            </AppWell>

            <div class="p-5">
                <div class="flex justify-between">
                    <div>
                        {{ $t('messages.survey_answer_similarities') }}
                    </div>
                </div>

                <div>
                    <AppWell>
                        <div class="flex flex-col gap-4 mt-3">
                            <div v-for="pair in analysis.pairs" :key="pair.key">
                                <div class="p-1">
                                    <div>
                                        {{ pair.similarity }}
                                    </div>
                                    <div class="grid md:grid-cols-2 gap-4">
                                        <AppCard v-for="answer in pair.texts" :key="answer.key">
                                            <div class="p-1">
                                                <div class="flex gap-1 items-center">
                                                    <ZoomableAvatar
                                                        :avatar="answer.user.avatar_or_default"
                                                        :title="answer.user.full_name"
                                                    />
                                                    <div>
                                                        {{ answer.user.full_name }}
                                                    </div>
                                                </div>
                                                <div class="mt-3">
                                                    {{ answer.text }}
                                                </div>
                                            </div>
                                        </AppCard>
                                    </div>
                                </div>

                                <AppCard class="mp-5">
                                    <div class="p-1">
                                        <div>
                                            <span v-html="pair.diff" class="diff" />
                                        </div>
                                    </div>
                                </AppCard>
                            </div>
                        </div>
                    </AppWell>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SmartBreadcrumbs from '../../../../../components/SmartBreadcrumbs.vue';
import AppCard from '../../../../../Shared/AppCard.vue';
import AppWell from '../../../../../Shared/AppWell.vue';
import ZoomableAvatar from '../../../../../components/ZoomableAvatar.vue';

export default {
    components: {
        ZoomableAvatar,
        AppWell,
        AppCard,
        SmartBreadcrumbs,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'survey', 'question', 'analysis'],
};
</script>
